/*    
<summary>
   This functional common component provides tooltip for showing some additional info.
   Developer:Aashish Singh, Created Date:23-Sept-2024
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/
import React from 'react';
import { formatMessage } from '../../translations/format-message';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import './popover.css';
import preferencesStore from '../../core/stores/preferences-store';

interface IProps {
    message: string;
    enurl: string;
    jpurl: string;
    id: string;
}
const { getLanguage } = preferencesStore;
const baseenUrl = "https://docs.monoz.io/docs/monoZLink/";
const basejpUrl = "https://docs.monoz.io/ja/docs/monoZLink/";

const CustomPopover = (props: IProps) => {
    const popover = (
        <Popover id="popover-basic">
            <Popover.Content>
                {formatMessage(props.message)}
                <a className='d-block text-primary' href={`${getLanguage == 'en' ? baseenUrl + props.enurl : basejpUrl + props.jpurl}`} target="_blank">
                    <FormattedMessage id="read_more" />
                </a>
            </Popover.Content>
        </Popover>
    );

    return (
        <>
            <OverlayTrigger trigger="click" rootClose={true} placement="right" overlay={popover}>
                <span>
                    <svg version="1.1" id="fi_471664" x="0px" y="0px" viewBox="0 0 512 512"  fill='currentColor' width="18" height="18" className='ms-2 popover-icon'>
                        <g>
                            <g>
                                <path d="M256,0C114.509,0,0,114.496,0,256c0,141.489,114.496,256,256,256c141.491,0,256-114.496,256-256
			C512,114.509,397.504,0,256,0z M256,476.279c-121.462,0-220.279-98.816-220.279-220.279S134.538,35.721,256,35.721
			c121.463,0,220.279,98.816,220.279,220.279S377.463,476.279,256,476.279z"></path>
                            </g>
                        </g>
                        <g>
                            <g>
                                <path d="M248.425,323.924c-14.153,0-25.61,11.794-25.61,25.946c0,13.817,11.12,25.948,25.61,25.948
			c14.49,0,25.946-12.131,25.946-25.948C274.371,335.718,262.577,323.924,248.425,323.924z"></path>
                            </g>
                        </g>
                        <g>
                            <g>
                                <path d="M252.805,127.469c-45.492,0-66.384,26.959-66.384,45.155c0,13.142,11.12,19.208,20.218,19.208
			c18.197,0,10.784-25.948,45.155-25.948c16.848,0,30.328,7.414,30.328,22.915c0,18.196-18.871,28.642-29.991,38.077
			c-9.773,8.423-22.577,22.24-22.577,51.22c0,17.522,4.718,22.577,18.533,22.577c16.511,0,19.881-7.413,19.881-13.817
			c0-17.522,0.337-27.631,18.871-42.121c9.098-7.076,37.74-29.991,37.74-61.666S295.937,127.469,252.805,127.469z"></path>
                            </g>
                        </g>
                    </svg>
                </span>
            </OverlayTrigger>
        </>
    )
};

export default CustomPopover;